import React, { useState, useEffect } from 'react';
import styles from './Tetromino.module.css';
import useStore from '../../../../hooks/useStore';

const TETROMINO_SHAPES = {
    I: [
        [0, 1, 0, 0],
        [0, 1, 0, 0],
        [0, 1, 0, 0],
        [0, 1, 0, 0]
    ],
    L: [
        [0, 1, 0, 0],
        [0, 1, 0, 0],
        [0, 1, 1, 0],
        [0, 0, 0, 0]
    ],
    T: [
        [0, 0, 0, 0],
        [1, 1, 1, 0],
        [0, 1, 0, 0],
        [0, 0, 0, 0]
    ],
    O: [
        [0, 0, 0, 0],
        [0, 1, 1, 0],
        [0, 1, 1, 0],
        [0, 0, 0, 0]
    ]
};

const TETROMINO_COLORS = {
    I: '#FFDA27', 
    L: '#4DFF29',  
    T: '#294DFF',  
    O: '#DB29FF'   
};

const TETROMINO_ORDER = ['L', 'I', 'T', 'O'];

const getTetrominoByReferrals = (totalReferred) => {
    const index = Math.floor(totalReferred / 4) % TETROMINO_ORDER.length;
    const type = TETROMINO_ORDER[index];
    return {
        type,
        shape: TETROMINO_SHAPES[type],
        color: TETROMINO_COLORS[type]
    };
};

const Tetromino = () => {
    const { userStatus } = useStore();
    const { referral_count: totalReferred } = userStatus;
    const [currentTetromino, setCurrentTetromino] = useState(null);

    useEffect(() => {
        setCurrentTetromino(getTetrominoByReferrals(totalReferred));
    }, [totalReferred]);

    if (!currentTetromino) return null;

    return (
        <div className={styles.tetrominoSectionWrapper}>
            <div className={styles.tetrominoSection}>
                <span className={styles.tetrominoTitle}>Progress to next Tetromino</span>
                <div className={styles.gridContainer}>
                    <div className={styles.tetrominoGrid}>
                        <div className={styles.gridBackground}>
                            {[0, 1, 2, 3].map((row) => (
                                <div key={`grid-${row}`} className={styles.gridRow}>
                                    {[0, 1, 2, 3].map((col) => (
                                        <div
                                            key={`grid-${row}-${col}`}
                                            className={styles.gridBlock}
                                            style={{
                                                backgroundColor: 'transparent',
                                                border: '1px solid #333'
                                            }}
                                        />
                                    ))}
                                </div>
                            ))}
                        </div>

                        <div className={styles.tetrominoLayer}>
                            {currentTetromino.shape.map((row, rowIndex) => (
                                <div key={rowIndex} className={styles.tetrominoRow} style={{top: `${rowIndex * 34}px`}}>
                                    {row.map((cell, cellIndex) => {
                                        const blockIndex = currentTetromino.shape.slice(0, rowIndex)
                                            .reduce((count, row) => count + row.reduce((sum, cell) => sum + cell, 0), 0)
                                            + row.slice(0, cellIndex + 1).reduce((sum, cell) => sum + cell, 0) - 1;
                                        
                                        const isBlockFilled = blockIndex < (totalReferred % 4);
                                        
                                        return (
                                            <div
                                                key={cellIndex}
                                                className={`${styles.tetrominoBlock} ${isBlockFilled && cell === 1 ? styles.filled : ''}`}
                                                style={{
                                                    backgroundColor: cell === 1 ? (
                                                        isBlockFilled 
                                                            ? currentTetromino.color 
                                                            : `${currentTetromino.color}30`
                                                    ) : 'transparent',
                                                    left: `${cellIndex * 34}px`
                                                }}
                                            />
                                        );
                                    })}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className={styles.progressText}>
                    {totalReferred % 4}/4 Referrals
                </div>
            </div>
        </div>
    );
};

export default Tetromino;

